<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { computedAsync } from '@vueuse/core';
import { useAlerts } from '@/plugins/alerts';
import { useLocalization } from '@/plugins/localization';
import DashboardsService, { DashboardModel } from '../services/DashboardsService';
import DashboardGrid from '../components/helpers/DashboardGrid.vue';

const { $alert } = useAlerts();
const { $t } = useLocalization();

const loaded = ref(false);
const dashboardId = ref<number>(null);
const userDashboardId = ref<number>(null);
const dashboard = ref<DashboardModel>({ id: 0, widgets: [] });

const dashboards = computedAsync(async () =>
{
    try
    {
        return await DashboardsService.getOptions();
    }
    catch (ex: any)
    {
        return [];
    }
},
[], { lazy: true });

async function setUserDashboard()
{
    try
    {
        await DashboardsService.setUserDashboard(dashboardId.value);
        userDashboardId.value = dashboardId.value;
    }
    catch (ex: any)
    {
        $alert.error($t('[[[Nie udało się zapisać ustawień dashboardu]]]'));
    }
}

watch(dashboardId, async (id) =>
{
    try
    {
        loaded.value = false;

        if (id && id != dashboard.value.id)
        {
            dashboard.value = await DashboardsService.getDashboard(id);
        }
    }
    catch (ex: any)
    {
        $alert.error($t('[[[Nie udało się pobrać konfiguracji dashboardu]]]'));
    }
    finally
    {
        loaded.value = true;
    }
});

onMounted(async () =>
{
    try
    {
        dashboard.value = await DashboardsService.getUserDashboard();
        userDashboardId.value = dashboard.value.id;
        dashboardId.value = dashboard.value.id;
    }
    catch (ex: any)
    {
        $alert.error($t('[[[Nie udało się pobrać konfiguracji dashboardu]]]'));
    }
});
</script>

<template>
    <div class="d-flex flex-column h-100">
        <div class="py-2 px-3 mt-n3 mx-n3 dashboard-header position-relative z-3">
            <div class="d-flex align-items-center flex-wrap">
                <div v-if="dashboards.length" class="d-flex gap-2">
                    <IdeoFormSelect v-model="dashboardId" :options="dashboards" />
                    <IdeoButton v-if="userDashboardId != dashboardId" variant="success" @click="setUserDashboard">{{ $t('[[[Zapisz]]]') }}</IdeoButton>
                </div>
            </div>
        </div>
        <DashboardGrid :widgets="dashboard.widgets" v-if="loaded" />
    </div>
</template>
